import React from 'react';
import { MessageCircle } from 'lucide-react';
import { STAGES, PRIORITIES } from './api';

// "Deal Tile" grid — stage-coloured header band, big ₹, and a pipeline progress bar.
const PIPE = ['new', 'contacted', 'qualified', 'demo', 'proposal', 'negotiation', 'won'];
const AV = [['#10b981', '#0e7490'], ['#6366f1', '#8b5cf6'], ['#f59e0b', '#c99700'], ['#f43f5e', '#fb7185'], ['#0ea5e9', '#0e7490'], ['#14b8a6', '#0b6e3e']];
const grad = (n) => { const g = AV[(n || 'x').charCodeAt(0) % AV.length]; return `linear-gradient(135deg,${g[0]},${g[1]})`; };
const stage = (k) => STAGES.find((s) => s.key === k) || { label: k, color: '#94a3b8' };
const prio = (p) => PRIORITIES.find((x) => x.key === p) || PRIORITIES[1];
const inr = (v) => '₹' + Number(v || 0).toLocaleString('en-IN');

export default function LeadGrid({ leads, onOpen, onWhatsApp }) {
  return (
    <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fill,minmax(250px,1fr))' }}>
      {leads.map((l) => {
        const s = stage(l.status);
        const p = prio(l.priority);
        const idx = PIPE.indexOf(l.status); // -1 when lost
        return (
          <div key={l.id} onClick={() => onOpen(l.id)}
            className="bg-[var(--card)] border border-[var(--border)] rounded-2xl card-lux overflow-hidden cursor-pointer hover:-translate-y-0.5 transition-transform">
            <div className="px-4 py-2 flex items-center justify-between" style={{ background: s.color }}>
              <span className="text-[11px] font-extrabold uppercase tracking-wide text-white">{s.label}</span>
              <span className="text-[11px] font-extrabold text-white/90">{l.priority === 'hot' ? '🔥 Hot' : p.label}</span>
            </div>
            <div className="p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl flex items-center justify-center text-white font-extrabold text-sm shrink-0" style={{ background: grad(l.name) }}>{(l.name || '?').slice(0, 1).toUpperCase()}</div>
                <div className="min-w-0">
                  <div className="font-extrabold text-[14px] text-[var(--text)] truncate">{l.name || '(no name)'}</div>
                  <div className="text-[11.5px] text-[var(--muted)] truncate">{l.company || '—'}</div>
                </div>
              </div>
              <div className="mt-3 text-[22px] font-extrabold tracking-tight" style={{ color: l.value ? 'var(--text)' : 'var(--muted)' }}>
                {l.value ? inr(l.value) : 'Yet to quote'}
              </div>
              <div className="flex gap-1 mt-3">
                {PIPE.map((_, i) => (
                  <span key={i} className="h-[5px] flex-1 rounded-full" style={{ background: idx >= 0 && i <= idx ? s.color : 'var(--soft)' }} />
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between gap-2">
                <span className="text-[11.5px] text-[var(--muted)] truncate">{l.interest || '—'}</span>
                <div className="flex items-center gap-2 shrink-0">
                  {onWhatsApp && l.phone && (
                    <button onClick={(e) => { e.stopPropagation(); onWhatsApp(l.phone); }}
                      className="w-7 h-7 rounded-lg flex items-center justify-center text-emerald-600 bg-emerald-50 hover:bg-emerald-100" title="WhatsApp"><MessageCircle size={15} /></button>
                  )}
                  <span className="text-[9.5px] font-extrabold uppercase tracking-wide text-[var(--muted)]">{l.source}</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
